import React, { useEffect, useMemo, useState } from 'react';
import { useI18n } from '../../i18n';
import PremiereLogo from './PremiereLogo';
import {
  PLATFORM_LABEL,
  PREMIERE_PAGE_URL,
  detectPlatform,
  premiereDownloadLink,
  trackPremiereClick,
  trackPremiereDownload,
} from './premiereExtension';
import './PremiereEditorCard.css';

/* Floating card in the caption editor (Simple and Studio views). Desktop only:
 * the extension is for people editing on a computer. */
const PremiereEditorCard = () => {
  const { t } = useI18n();
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    setPlatform(detectPlatform());
  }, []);

  const download = useMemo(
    () => (platform ? premiereDownloadLink(platform, 'editor') : null),
    [platform],
  );

  return (
    <aside className="premiere-editor-card" aria-label={t('ArabCap for Premiere Pro')}>
      <PremiereLogo className="premiere-editor-card__logo" />
      <div className="premiere-editor-card__copy">
        <p className="premiere-editor-card__title">{t('Caption inside Premiere Pro')}</p>
        <p className="premiere-editor-card__sub">{t('Free extension · captions straight on your timeline')}</p>
        <div className="premiere-editor-card__actions">
          {platform && (
            <a
              href={download.href}
              onClick={() => trackPremiereDownload('editor', platform, download.eventId)}
              className="premiere-editor-card__cta"
            >
              {t('Download for {os}', { os: PLATFORM_LABEL[platform] })}
            </a>
          )}
          <a
            href={PREMIERE_PAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackPremiereClick('see_more', 'editor', platform)}
            className="premiere-editor-card__more"
          >
            {t('See more')} <span className="inline-block rtl:-scale-x-100">→</span>
          </a>
        </div>
      </div>
    </aside>
  );
};

export default PremiereEditorCard;
